module.exports = __webpack_public_path__ + "static/media/ic_close_thin.227ddc06.svg";